import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as Common from './Common';
import * as User from './User';
import * as Account from './Account';
import * as Payment from './Payment';
import * as Profile from './Profile';
import * as Service from './Service';

export default function configureStore(history, initialState) {
    const reducers = {
        common: Common.reducer,
        user: User.reducer,
        account: Account.reducer,
        payment: Payment.reducer,
        profile: Profile.reducer,
        service: Service.reducer
    };

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}
